//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'gift_pack_card',
  filters: {
    titleFilter: function titleFilter(v) {
      return {
        1: '演示卡（含自选礼包）',
        2: '演示卡（含自选礼包）',
        3: '演示卡（含自选礼包）',
        4: '五一慰问福利卡',
        5: '五一慰问福利卡'
      };
    }
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};